import React, { useState, useEffect } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
import moment from "moment";
import _ from "lodash";
import "moment/locale/fr";

export default function ModalUpdateDeleteMenus(props) {
  const [styleFadeIn, setFadeIn] = useState(true);
  const [textrepsPetit, settextrepsPetit] = useState(
    props.eventEdit.menuDesPetits
  );
  const [textrepsGrands, settextrepsGrands] = useState(
    props.eventEdit.menuDesGrands
  );
  const [isChange, setChange] = useState(false);
  useEffect(() => {
    if (!_.isEmpty(textrepsPetit) || !_.isEmpty(textrepsGrands)) {
    } else {
      setChange(false);
    }
  }, [textrepsPetit, textrepsGrands]);

  const myChangeHandler = (event) => {
    setChange(true);
    if (event.target.name === "textrepsPetit") {
      settextrepsPetit(event.target.value);
    } else {
      settextrepsGrands(event.target.value);
    }
  };
  const CloseModalUpdateDeletetRepas = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.closeModalUpdateDeletetRepas();
    }, 400);
  }, []);
  const Modifier = () => {
    props.handleModifieRepas(textrepsPetit, textrepsGrands);
  };
  const Supprimer = () => {
    props.handleRepasDelete(textrepsPetit, textrepsGrands);
  };
  const { eventEdit } = props;
  moment.locale("fr");
  return (
    <StyleRoot>
      <div
        className="modal show fade modal-skin"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        id="modalRepas"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        data-radium="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-bg"
          role="document"
        >
          <div className="modal-content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                Modifier();
              }}
            >
              <button
                onClick={CloseModalUpdateDeletetRepas}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close className="img-fluid" alt="" />
              </button>
              <div className="modal-body fiche-enfant">
                <h5 className="modal-title">
                  {"Repas du " +
                    moment(eventEdit.start, "yyyy-MM-DD").format(
                      "DD MMMM YYYY"
                    )}
                </h5>
                <p className="bottom-space"></p>
                <section className="content-section">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-12">
                      <div className="form-group h-200 m-0">
                        <textarea
                          className="form-control ipt-id-baby"
                          name="textrepsPetit"
                          onChange={(event) => myChangeHandler(event)}
                          defaultValue={props.eventEdit.menuDesPetits}
                          value={textrepsPetit}
                          placeholder="Menu des petits"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3">
                    <div className="col-md-12">
                      <div className="form-group h-200 m-0">
                        <textarea
                          className="form-control ipt-id-child"
                          name="textrepsGrand"
                          onChange={(event) => myChangeHandler(event)}
                          defaultValue={props.eventEdit.menuDesGrands}
                          value={textrepsGrands}
                          placeholder="Menu des grands"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </section>
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn-gradient btn-delete"
                    data-dismiss="modal"
                    onClick={Supprimer}
                  >
                    Supprimer
                  </button>
                  <button
                    type="submit"
                    style={isChange ? { opacity: 1 } : { opacity: 0.25 }}
                    className="btn-gradient btn-valid"
                    data-dismiss="modal"
                  >
                    Modifier
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
